/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import _ from 'lodash'
import { Button } from '@styles/button.style'
import { RewardListWrap } from '@views/FriendsInvitation/index.style'
import rewardCoinReceiveImg from '@assets/images/bg/reward-coin-receice.png'
import rewardCoinStandardImg from '@assets/images/bg/reward-coin-standard.png'
import rewardCoinReceivedImg from '@assets/images/bg/reward-coin-receiced.png'
import { Schema$UserActivityReward, Schema$UserActivityRewardHistory } from '@interface/user-activity'
import classNames from 'classnames'
import useRootStore from '@store/useRootStore'

interface ActivityRewardListProps {
  activityRewardHistory: Schema$UserActivityRewardHistory
}

export const ActivityRewardList: React.FC<ActivityRewardListProps> = observer((props) => {
  const { userStore } = useRootStore()
  const {
    activityRewardHistory,
  } = props
  const { rewardList, activityScore, baseMonth } = activityRewardHistory || {
    rewardList: [] as Schema$UserActivityReward[], activityScore: 0, baseMonth: '',
  }

  const onClickRewardReceive = (reward: Schema$UserActivityReward): void => {
    if (reward.rewardReceived) {
      return
    }
    if (reward.rewardConditionScore > activityScore) {
      return
    }
    userStore.receiveMyActivityReward(baseMonth, reward.rewardDefId).catch(console.error)
  }

  const rewardCoinStandard = <img src={rewardCoinStandardImg} className="reward-money-img" alt="보상이미지"/>
  const rewardCoinReceive = <img src={rewardCoinReceiveImg} className="reward-money-img" alt="수령받을 보상이미지"/>
  const rewardCoinReceived = <img src={rewardCoinReceivedImg} className="reward-money-img" alt="수령받은 보상이미지"/>

  const formatter = new Intl.NumberFormat()
  let rewardAvailableIdx = -1
  const rewardElemList = _.map(rewardList, (reward, idx) => {
    let scoreGaugePercent: number
    const prevScore = idx === 0 ? 0 : rewardList[idx - 1].rewardConditionScore
    const currScore = reward.rewardConditionScore
    // 1200 점이라면
    // 1구간(500점): 100%
    // 2구간(1000점): 100%
    // 3구간(1500점): (1200 - 1000) / (1500 - 1000) * 100 = 40%
    // 4구간(2000점): 0%
    if (reward.rewardConditionScore <= activityScore) {
      scoreGaugePercent = 100
    } else if (prevScore < activityScore && currScore > activityScore) {
      scoreGaugePercent = Math.floor((activityScore - prevScore) / (currScore - prevScore) * 100)
    } else {
      scoreGaugePercent = 0
    }

    const listItemClassNames = classNames(
      'reward-list--item', {
        'arrival': reward.rewardConditionScore <= activityScore,
        'complete': reward.rewardReceived,
      },
    )

    let rewardCoinImg = rewardCoinReceived
    if (reward.rewardReceived) {
      rewardCoinImg = rewardCoinReceived
    } else if (reward.rewardConditionScore <= activityScore) {
      rewardCoinImg = rewardCoinReceive
      if (rewardAvailableIdx === -1) {
        rewardAvailableIdx = idx
      }
    } else {
      rewardCoinImg = rewardCoinStandard
    }

    return (
      <li key={`user-activity-reward-list-${reward.rewardDefId}`} className={listItemClassNames}>
        <span className="range">{formatter.format(reward.rewardConditionScore)}점</span>

        {/* 구간별 보상 영역 */}
        <Button className="reward-box" onClick={() => onClickRewardReceive(reward)}>
          {reward.rewardDefTitle}
          {rewardCoinImg}
          <span className="reward-btn">수령</span>
          <span className="check-ico"/>
        </Button>

        <span className="gauge-bar" style={{ width: `${scoreGaugePercent}%` }}></span>
        {/* 금액 구간 달성 시 연출 */}
        <span className={reward.rewardReceived ? 'circle complete' : 'circle'}>
          <span className="pulse-ani"/>
          <span className="pulse-ani ani-2"/>
          <span className="pulse-ani ani-3"/>
        </span>
      </li>
    )
  })

  useEffect(() => {
    setTimeout(() => {
      const elem = document.querySelector('.full-modal .reward-item-list.activity-score')
      if (elem) {
        console.log('================== rewardAvailableIdx', rewardAvailableIdx)
        if (rewardAvailableIdx > 0) {
          elem.scrollLeft = 103 * rewardAvailableIdx
        } else {
          elem.scrollLeft = 0
        }
      }
    }, 1)
  }, [baseMonth])

  const wrapClassNames = classNames('reward-item-list activity-score', {
    'm-reward-list-wrap': isMobile,
  })
  return (
    <RewardListWrap className={wrapClassNames}>
      <ul className="reward-list activity-reward">
        {rewardElemList}
      </ul>
    </RewardListWrap>
  )
})
